export default __webpack_public_path__ + "static/media/smsIcon.5a1e14ab.png";